import { MutableRefObject, useCallback, useEffect, useRef, useState } from "react";
import Articlegroup from "../../../../global/utils/models/menu/Articlegroup.ts";
import { ButtonBase } from "@mui/material";
import Box from "@mui/material/Box";
import clsx from "clsx";
import Image from "../../../../global/components/Image.tsx";
// @ts-ignore
import JamezzLogo from "../../../../assets/images/JamezzLogo.svg";
import IconButton from "@mui/material/IconButton";
import { ArrowBackIos } from "@mui/icons-material";
// @ts-ignore
import scrollIntoView from "scroll-into-view";

import { useDialog } from "../../../../global/utils/dialog/DialogProvider.tsx";
import FormattedMessageJamezz from "../../../../global/components/FormattedMessageJamezz.tsx";
import store, { useAppDispatch, useAppSelector } from "../../../../global/utils/redux/store.tsx";
import { setSelectedArticlegroup } from "../../../../global/utils/redux/menuSlice.ts";
import { useGoToHomeKiosk } from "../../ReturnPage/ReturnPage.tsx";
import { AreYouSureStartOverDialog } from "../../../components/AreYouSureStartOverDialog.tsx";
import VerticalArticlegroupTab from "./VerticalArticlegroupTab.tsx";

interface Props {
  articlegroups: Articlegroup[];
  verticalArticlegroupTabRef: MutableRefObject<any>;
  width: number;
}

export default function VerticalArticlegroupTabBar(props: Props) {
  const dispatch = useAppDispatch();
  const { openDialog } = useDialog();

  const goToHome = useGoToHomeKiosk();

  const articlegroupsShortcutPage = useAppSelector((state) => state.global.salesarea?.articlegroups_shortcut_page);
  const logoImage = useAppSelector(
    (state) => state.global.salesarea?.media_urls?.logoImage?.[0]?.conversions?.optimized?.url
  );
  const [isToTopScrollable, setToTopIsScrollable] = useState(false);
  const [isToDownScrollable, setToDownIsScrollable] = useState(false);

  const box = useRef<any>(null);
  const home = useRef<any>(null);

  const onScroll = useCallback(() => {
    if (box.current) {
      if (box.current.scrollTop + box.current.clientHeight < box.current.scrollHeight) {
        if (!isToDownScrollable) {
          setToDownIsScrollable(true);
        }
      } else {
        if (isToDownScrollable) {
          setToDownIsScrollable(false);
        }
      }
      if (box.current.scrollTop > 0) {
        if (!isToTopScrollable) {
          setToTopIsScrollable(true);
        }
      } else {
        if (isToTopScrollable) {
          setToTopIsScrollable(false);
        }
      }
    }
  }, [isToDownScrollable, isToTopScrollable]);

  useEffect(() => {
    const element = box.current;
    if (element) {
      element.addEventListener("scroll", onScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", onScroll);
      }
    };
  }, [onScroll]);

  useEffect(() => {
    onScroll();
  }, []);

  return (
    <Box
      ref={props.verticalArticlegroupTabRef}
      className={"JS-VerticalArticlegroupTab-Root"}
      sx={{
        width: props.width,
        height: 1,
        backgroundColor: "primary.light",
        position: "relative",
      }}
    >
      <Box
        className={"JS-VerticalArticlegroupTab-Container"}
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          paddingX: 4,
          paddingY: 2,
          height: 1,
          position: "relative",
        }}
        ref={box}
      >
        {/*<FixSelectedArticlegroup articlegroups={props.articlegroups} />*/}
        <ButtonBase
          ref={home}
          id={"JS-VerticalArticlegroupTab-Home"}
          className={clsx("JS-VerticalArticlegroupTab-Home")}
          onClick={() => {
            if (articlegroupsShortcutPage && store.getState().menu.selectedArticlegroup != null) {
              dispatch(setSelectedArticlegroup({ articlegroup: null }));
              return;
            }
            openDialog({
              children: (
                <AreYouSureStartOverDialog
                  message={<FormattedMessageJamezz id={"Are you sure you want to start over?"} />}
                  onOk={() => {
                    goToHome();
                  }}
                  CancelText={<FormattedMessageJamezz id={"Cancel order"} />}
                  OkText={
                    <>
                      <FormattedMessageJamezz id={"Continue ordering"} />
                      ...
                    </>
                  }
                />
              ),
              sx: {
                ".MuiDialog-paper": {
                  borderRadius: 6,
                },
              },
            });
          }}
          sx={{ width: 1 }}
        >
          <Box
            sx={{
              width: 1,
              height: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              className={"JS-VerticalArticlegroupTab-LogoWrapper"}
              sx={{ height: 1, width: 1, flex: "1", textAlign: "center", padding: 1 }}
            >
              {!logoImage && <img src={JamezzLogo} style={{ height: "100%", width: "100%", objectFit: "contain" }} />}
              {logoImage && <Image src={logoImage} style={{ height: "100%", width: "100%", objectFit: "contain" }} />}
            </Box>
            {/*{articlegroup.imageSrcs[0] ? (*/}
            {/*  <img*/}
            {/*    src={articlegroup.imageSrcs[0]}*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*      flex: 1,*/}
            {/*      objectFit: "contain",*/}
            {/*    }}*/}
            {/*  />*/}
            {/*) : (*/}
            {/*  <Typography sx={{ width: 1, flex: 1, height: 0, minHeight: 150 }}></Typography>*/}
            {/*)}*/}
            {/*<Typography*/}
            {/*  className={"JS-VerticalArticlegroupTab-Text"}*/}
            {/*  sx={{ fontSize: (theme) => theme.typography.fontSize * 32 / 32, color: "primary.main", width: 1, overflowWrap: "break-word" }}*/}
            {/*>*/}
            {/*  {articlegroup.alternativeName1 ?? articlegroup.name}*/}
            {/*</Typography>*/}
          </Box>
        </ButtonBase>

        {props.articlegroups?.map((articlegroup) => {
          if (articlegroup.showInCategoryMenu) {
            return <VerticalArticlegroupTab articlegroup={articlegroup} />;
          }
        })}
      </Box>
      {isToTopScrollable && (
        <IconButton
          className={"JS-VerticalArticlegroupTab-ButtonTop"}
          size={"large"}
          sx={{
            zIndex: 10,
            position: "absolute",
            top: 0,
            marginX: "auto",
            width: 1,
            color: "primary.dark",
          }}
          aria-label="close"
          onClick={() => {
            const element = home.current;
            scrollIntoView(
              element,
              {
                time: 200,
                align: {
                  top: 0,
                  topOffset: 600 - box.current.scrollTop, // margin
                },
                validTarget: () => true,
              },
              () => {}
            );
          }}
        >
          {/*<Bouncer>*/}
          <ArrowBackIos sx={{ width: 120, height: 120, transform: "rotate(90deg)", transformOrigin: "center" }} />
          {/*</Bouncer>*/}
        </IconButton>
      )}
      {isToDownScrollable && (
        <IconButton
          className={"JS-VerticalArticlegroupTab-ButtonDown"}
          size={"large"}
          sx={{
            zIndex: 10,
            position: "absolute",
            bottom: 0,
            marginX: "auto",
            width: 1,
            color: "primary.dark",
          }}
          aria-label="close"
          onClick={() => {
            const element = home.current;
            scrollIntoView(
              element,
              {
                time: 200,
                align: {
                  top: 0,
                  topOffset: -600 - box.current.scrollTop, // margin
                },
                validTarget: () => true,
              },
              () => {}
            );
          }}
        >
          {/*<Bouncer>*/}
          <ArrowBackIos sx={{ width: 120, height: 120, transform: "rotate(-90deg)", transformOrigin: "center" }} />
          {/*</Bouncer>*/}
        </IconButton>
      )}
    </Box>
  );
}
